(function($){

	/* Case Studies Tabs */

	$(document).ready(function () {
	    $('.tabs a').click(function () {
	        $('.panel').hide();
	        $('.tabs a.active').removeClass('active');
	        $(this).addClass('active');
	        var panel = $(this).attr('href');
	        $(panel).fadeIn(1000);
	        console.log("Testing click")
	        return false;
	    });

	    $('.tabs li:first a').click();
	    
	    function showCompare(text) {
	        let letter = text.charAt(text.length - 1);
	        console.log("Letter:"+letter)

	        $(`.compare-section-main .compare-section`).hide();
	        //$(`.compare-section-main .compare-section:nth-child(${letter})`).show();
	        $("#compare-section"+letter).show()
	    }

	    let text = $('.tabs-row ul li a.active').attr('href');
	    showCompare(text);

	    $('.tabs-row ul li a').on('click', function () {
	        let href = $(this).attr('href');
	        showCompare(href);
	    });
	});

	$(window).on('load', function(e) {
	    if (window.location.hash == "#panel2") {
	        $('.tabs-row ul li:nth-child(2) a').trigger("click");
	    }
	    if (window.location.hash == "#panel3") {
	        $('.tabs-row ul li:nth-child(3) a').trigger("click");
	    }
	    if (window.location.hash == "#panel4") {
	        $('.tabs-row ul li:nth-child(4) a').trigger("click");
	    }
	    if (window.location.hash == "#panel5") {
	        $('.tabs-row ul li:nth-child(5) a').trigger("click");
	    }
	    if (window.location.hash == "#panel6") {
	        $('.tabs-row ul li:nth-child(6) a').trigger("click");
	    }
	    if (window.location.hash == "#panel7") {
	        $('.tabs-row ul li:nth-child(7) a').trigger("click");
	    }
	});


	/* Case Studies Accordions */

	$(document).ready(function () {
        $(".set > .click-link").on("click", function () {
            if ($(this).hasClass("active-tab")) {
                $(this).removeClass("active-tab");
                $(this).siblings(".content").slideUp(200);
                $(".set > .click-link span").removeClass("fa_minus").addClass("fa_plus");
            } else {
                $(".set > .click-link span").removeClass("fa_minus").addClass("fa_plus");
                $(this).find("span").removeClass("fa_plus").addClass("fa_minus");
                $(".set > .click-link").removeClass("active-tab");
                $(this).addClass("active-tab");
                $(".content").slideUp(200);
                $(this).siblings(".content").slideDown(200);
            }
        });

        function showProduct(text) {
  			let letter = text.charAt(text.length-1);
      		$(`.real-skin-products .real-skin-product-item, .accordion-container .accordion-container-inner`).hide();
			$(`.real-skin-products .real-skin-product-item:nth-child(${letter}), .accordion-container .accordion-container-inner:nth-child(${letter})`).show();
        	$('.accordion-container-inner .set:first-child .click-link').addClass('active-tab');
        	$('.accordion-container-inner .set:first-child .click-link span').addClass('fa_minus').removeClass('fa_plus');
            $('.accordion-container-inner .set:first-child .content').show();
		}

		let text = $('.tabs-row ul li a.active').attr('href');
      	showProduct(text);

      	$('.tabs-row ul li a').on('click',function(){
			let href = $(this).attr('href');
        	showProduct(href);    
		});
    });

})(jQuery);